import { useEffect, useState } from 'react';
import { Building } from '../../confi-state';
import { ServiceManager } from '../../services/service-manager';
import styles from './BuildingInfoDoc.module.css';

const BuildingInfoDoc = ({ building }: { building: Building }) => {

    const [ufa, setUfa] = useState<number>(0);
    const [gfa, setGfa] = useState<number>(0);
    const [totalApartments, setTotalApartments] = useState<number>(0);
    const [totalPrice, setTotalPrice] = useState<string>('0');
    const [buildingType, setBuildingType] = useState<string>('');

    const [nrSiteTypeUnits, setNrSiteTypeUnits] = useState<{ label: string, total: number, types: { type: string, nr: number }[] }[]>([]);

    const computeTotalPrice = () => {
        if (building) {
            return ServiceManager.buildingHelperService.calculateCostOfSite([building]).toLocaleString('nl-NL', {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            })
        } else {
            return '0';
        }
    }
    useEffect(() => {
        setUfa(ServiceManager.buildingHelperService.calculateTotalUFAOfSite([building]));
        setGfa(ServiceManager.buildingHelperService.calculateTotalGFAOfSite([building]));
        setNrSiteTypeUnits(ServiceManager.buildingHelperService.calculateNrOfUnitsPerType([building]));
        setTotalApartments(ServiceManager.buildingHelperService.calculateTotalAppartmentsOfSite([building]));
        setTotalPrice(computeTotalPrice());
        setBuildingType(ServiceManager.buildingHelperService.getNameBuildingType(building.type));
    }, [])


    return (
        <div className={styles.BuildingInfoDoc} data-testid="BuildingInfoDoc">
            <div >
                <h3>Kern gegevens</h3>
                <hr></hr>
                <div className={styles.info}>
                    <div className={styles.half}>
                        <dl>
                            <dt>
                                Gebruiksoppervlak (GO)
                            </dt>
                            <dd data-testid="SiteGO">
                                {Math.round(ufa).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0, })} ㎡
                            </dd>
                            <dt>
                                Bruto vloeroppervlak (BVO)
                            </dt>
                            <dd data-testid="SiteBVO">
                                {Math.round(gfa).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ㎡
                            </dd>
                            <dt>
                                GO/BVO
                            </dt>
                            <dd>
                                {gfa !== 0 ? (ufa / gfa).toFixed(2) : 0}
                            </dd>
                        </dl>
                    </div>
                </div>
                <h3><span>Woningen</span><span className={styles.right}>{totalApartments}</span></h3>
                <hr></hr>
                <div className={styles.unitNumbers}>
                    {
                        nrSiteTypeUnits.map((n, index) => {
                            return n.total > 0 && (<div data-key={n.label + index + Math.random()} key={n.label + index + Math.random()} className={styles.third}>
                                <h3><span>{n.label}</span><span className={styles.right}>{n.total}</span></h3>
                                <hr></hr>
                                <ul>
                                    {n.types.map((t, index) => {
                                        return (<li  data-key={n.label + t.type + index} key={n.label + t.type + index}><span>{t.type}</span><span className={styles.right}>{t.nr}</span></li>)
                                    })}
                                </ul>
                            </div>)
                        })
                    }
                </div>
            </div>
        </div >
    )
};

export default BuildingInfoDoc;
